import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=b79047ca&scoped=true&"
import script from "./Reservations.vue?vue&type=script&lang=ts&"
export * from "./Reservations.vue?vue&type=script&lang=ts&"
import style0 from "./Reservations.vue?vue&type=style&index=0&id=b79047ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79047ca",
  null
  
)

export default component.exports